<template>
    <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <g clip-path="url(#clip2)">
            <path d="M4 9.00781V0.992188M4 9.00781L1 6.00781M4 9.00781L7 6.00781" stroke="#202830" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
            <clipPath id="clip2">
                <rect width="8" height="10" fill="white"/>
            </clipPath>
        </defs>
    </svg>
</template>

<script>
export default {
    name: 'IconLower',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>
